<template>
  <div>
    <NuxtPage />
  </div>
</template>


<script setup>

  const { data } = await useAsyncData('model', async () => {
        const app = useNuxtApp()
        const req = app.ssrContext.event.req
        try {
          const { build } = useModelBuilder(req)
          const mod = await build()  
          return mod
        }
        catch(error) {
          console.log(error)
        }
    })  

  const model = useState("model", () => (data))


  onBeforeMount(() => {
    // using this approach as 'load' event has some issues with Safari
    // it does not render well may be becauase of a race condition.upon searching online
    //it was suggested to use readystatechange instead
    //https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
    document.addEventListener('readystatechange', (event) => {
      if (event.target.readyState === 'complete') {
        document.getElementsByTagName('body')[0].style.visibility = 'visible'
      }
    })    
  })

</script>

<style>

/* Don't show any components until the 'hydrated' class has been
     applied, otherwise you will get flicker of content in slots.  Some
     of the stencil copmonents already account for this, but some don't
     hp5-variable-content-block-vertical being one of them.
  */
  hp5-page-content-container:not(.hydrated) {
    visibility: hidden;
  }

  [v-cloak] {
    display: none;
  }
  .v-cloak {
    display: none;
  }
</style>